import _ from "lodash";

export const CONTENT_DASHBOARD_TABS_LIST = [
    {key: 'blog-posts', label: 'Blog Posts'},
    {key: 'product-blog-posts', label: 'Product Blog Posts'},
    {key: 'prompts', label: 'Prompts'},
];

export const DEFAULT_CONTENT_DASHBOARD_TAB = {key: 'blog-posts', label: 'Blog Posts'};

export const DATA_LIMIT = 40;
export const CONTENT_CONFIG_KEYS = {
    BLOG_POST_CATEGORY: 'blog-post-category-config',
};

export const CONTENT_CONFIG_TYPES = {
    BLOG_POST: 'blog-post',
    PRODUCT_BLOG_POST: 'product-blog-post',
};

export const HTML_CONTENT_TYPE_HEADERS = ['h1', 'h2', 'h3'];
export const HTML_CONTENT_TYPE_LIST_ITEMS = ['li'];

export const HTML_CONTENT_TYPE_LIST = [
    {key: 'h1', label: 'Heading 1', shortLabel: 'H1'},
    {key: 'h2', label: 'Heading 2', shortLabel: 'Section'},
    {key: 'h3', label: 'Heading 3', shortLabel: 'H3'},
    {key: 'p', label: 'Paragraph', shortLabel: 'P'},
    {key: 'br', label: 'New Line Paragraph', shortLabel: 'BR'},
    {key: 'blockquote', label: 'Quote', shortLabel: 'Quote'},
    {key: 'ol', label: 'Ordered List', shortLabel: 'OL'},
    {key: 'ul', label: 'Unordered List', shortLabel: 'UL'},
    {key: 'end', label: 'Conclusion', shortLabel: 'END'},
];

export const HTML_CONTENT_TYPE_MAP = _.keyBy(HTML_CONTENT_TYPE_LIST, 'key');

export const HTML_META_TYPE_LIST = [
    {key: 'excerpt', label: 'Excerpt', shortLabel: 'Excerpt'},
    {key: 'meta', label: 'Meta Description', shortLabel: 'Meta'},
    {key: 'tags', label: 'Tags', shortLabel: 'Tags'},
];

export const HTML_META_TYPE_MAP = _.keyBy(HTML_META_TYPE_LIST, 'key');

export const COLLECTION_META_TYPE_LIST = [
    {key: 'excerpt', label: 'Excerpt', shortLabel: 'Excerpt'},
    {key: 'seoTitle', label: 'Meta Title', shortLabel: 'Meta Title'},
    {key: 'seoDescription', label: 'Meta Description', shortLabel: 'Meta Description'},
];

export const COLLECTION_META_TYPE_MAP = _.keyBy(COLLECTION_META_TYPE_LIST, 'key');
